<template>
  <div id="document-grid-view">
    <VuePerfectScrollbar
      :style="{ maxHeight: scrollHeight }"
      :settings="scrollbarSettings"
    >
      <!-- ソート -->
      <div class="flex items-center px-2 mb-2">
        <v-select
          class="sort-select-box mr-2 w-48"
          v-model="sortTargetKey"
          :options="sortItems"
          :searchable="false"
          label="label"
          placeholder="並び替え"
          :clearable="false"
          @input="toggleSort()"
        >
        </v-select>
        <!-- 昇順/降順切り替え -->
        <feather-icon
          class="sort-switch"
          svgClasses="h-6 w-6"
          :color="AISEA_COLOR.GRAY"
          :icon="sortIcon"
          @click="toggleSort()"
        />
      </div>
      <div v-show="showFolder">
        <!-- フォルダ -->
        <div class="px-2 py-2">フォルダ</div>
        <div
          v-if="folderNotExists"
          id="file-not-exists"
          class="flex m-4 px-4 pb-4 align-middle"
        >
          <span>フォルダがありません</span>
        </div>
        <div v-else class="grid-folder-item flex flex-wrap pb-4">
          <div
            v-for="(document, index) in displayDocuments.folders"
            :key="'grid_folder' + index"
            class="flex xs: w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5"
          >
            <card :document="document" :isFolder="true"></card>
          </div>
        </div>
      </div>

      <!-- ファイル -->
      <div v-show="showFolder" class="px-2 py-2">ファイル</div>
      <div
        v-if="fileNotExists"
        id="file-not-exists"
        class="flex m-4 px-4 pb-4 align-middle"
      >
        <span>ファイルがありません</span>
      </div>
      <div v-else>
        <div class="grid-file-item flex flex-wrap">
          <div
            v-for="(document, index) in displayDocuments.files"
            :key="'grid_file' + index"
            class="flex xs: w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5"
          >
            <card :document="document" :isFolder="false"></card>
          </div>
        </div>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import { ColorMixin, DocumentMixin } from "@/mixins";
import Card from "./DocumentContentGridCard.vue"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { createNamespacedHelpers } from "vuex";
import vSelect from 'vue-select';

const {
  mapMutations: mapMutationsOfenterpriseDocumentManager,
  mapState: mapStateOfenterpriseDocumentManager,
  mapActions: mapActionsOfenterpriseDocumentManager
} = createNamespacedHelpers("enterpriseDocumentManager");

const SORT_ITEMS = [
  { key: "name", label: "名前", showFilepathOnly: false },
  { key: "path", label: "場所", showFilepathOnly: true }, //ファイルパスが表示されている場合のみ表示する
  { key: "size", label: "サイズ", showFilepathOnly: false },
  { key: "updated", label: "最終更新時間", showFilepathOnly: false },
];

export default {
  mixins: [ColorMixin, DocumentMixin],
  components: {
    Card,
    VuePerfectScrollbar,
    vSelect,
  },
  computed: {
    ...mapStateOfenterpriseDocumentManager([
      "displayDocuments",
      "showFolderList",
      "isSearching",
      "showListCardPath",
      "isSortOrderAsc",
      "sortKey"
    ]),
    scrollHeight () {
      return `${this.$store.state.windowHeight - 300}px`
    },
    folderNotExists () {
      if (!this.displayDocuments) return true
      return this.displayDocuments.folders.length === 0
    },
    fileNotExists () {
      if (!this.displayDocuments) return true
      return this.displayDocuments.files.length === 0
    },
    showFolder () {
      return this.showFolderList
    },
    showFilePath () {
      return this.isSearching || this.showListCardPath
    },
    sortItems () {
      if (this.showFilePath) { return SORT_ITEMS; }
      return SORT_ITEMS.filter(item => !item.showFilepathOnly);
    },
    sortIcon () {
      return this.isAsc ? "ArrowUpIcon" : "ArrowDownIcon";
    },
    isAsc: {
      get(){ 
        return this.isSortOrderAsc; 
      },
      set(val) {
        this.SET_IS_SORT_ORDER_ASC(val);
      }
    },
    sortTargetKey: {
      get(){ 
        return this.sortItems.find(item => item.key === this.sortKey); 
      },
      set(val) {
        this.SET_SORT_KEY(val.key);
      }
    }
  },
  methods: {
    ...mapMutationsOfenterpriseDocumentManager([
      "SET_SORT_KEY",
      "SET_IS_SORT_ORDER_ASC"
    ]),
    ...mapActionsOfenterpriseDocumentManager(["sortDocument"]),
    toggleSort () {
      this.isAsc = !this.isAsc;
      const payload = {
        key: this.sortTargetKey.key,
        isAsc: this.isAsc
      };
      this.sortDocument(payload);
    },
  }
}
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";
@import "src/assets/scss/vuexy/variables";
#document-grid-view {
  #file-not-exists {
    color: $aisea-gray;
  }

  .sort-select-box {
    color: $aisea-gray;

    .vs__selected {
      font-family: $aisea-font-family;
      font-size: 14px;
      font-weight: 400;
    }

    .vs__dropdown-menu {
      padding: 2px 0;
    }

    .vs__dropdown-menu li {
      font-family: $aisea-font-family;
      font-size: 14px;
      font-weight: 400;
    }
    .vs__dropdown-option--highlight {
      background-color: rgba($aisea-blue, .05);
      color: $aisea-blue !important;
      margin: 0 2px;
      border-radius: 2px;
    }
  }

  .sort-switch {
    color: $aisea-gray;
    cursor: pointer;
  }
}
</style>